<template>
  <div class="admin-wrapper">
    <!-- 头部 -->
    <app-header></app-header>
    <div class="auth-wrapper">
      <div class="inner">
        <h2 class="auth-title">
          <i></i>非认证用户不具操作权限！</h2>
        <p class="auth-desc">请按照以下范例，发送申请邮件至：<br>
          <a href="mailto:cs@zai-art.com">cs@zai-art.com</a>
        </p>
        <div class="auth-content">
          <div class="auth-item">
            <h3>· 个人用户认证</h3>
            <dl>
              <dt>[ 邮件标题 ]</dt>
              <dd>
                <p>达人申请-用户名-个人用户认证</p>
              </dd>
            </dl>
            <dl>
              <dt>[ 邮件标题 ]</dt>
              <dd>
                <p>用户名： 绮韵</p>
                <p>在艺号： 11111111</p>
                <p>真实姓名：成绮韵</p>
                <p>手机号码：18512341234</p>
                <p>常用邮箱：171488888@qq.com</p>
                <p>公司全名：在艺科技有限责任公司</p>
                <p>职位：内容运营</p>
              </dd>
            </dl>
            <dl>
              <dt>[ 邮件标题 ]</dt>
              <dd>
                <p>用户身份证正反面 或 护照封面和首页</p>
                <p>职位证明（如：名片/工牌/在职证明）</p>
              </dd>
            </dl>
          </div>
          <div class="auth-item">
            <h3>· 艺术家/策展人认证</h3>
            <dl>
              <dt>[ 邮件标题 ]</dt>
              <dd>
                <p>达人申请-用户名-艺术家/策展人认证</p>
              </dd>
            </dl>
            <dl>
              <dt>[ 邮件标题 ]</dt>
              <dd>
                <p>用户名：艺术家艾在艺</p>
                <p>在艺号： 11111111</p>
                <p>真实姓名：艾在艺</p>
                <p>手机号码：13912341234</p>
                <p>常用邮箱：aizy@163.com</p>
              </dd>
            </dl>
            <dl>
              <dt>[ 附件 ]</dt>
              <dd>
                <p>个人履历（需包含参展/策展经历）</p>
                <p>代表作品（认证策展人无需提交）</p>
                <p>用户身份证正反面 或 护照封面和首页</p>
              </dd>
            </dl>
          </div>
          <div class="auth-item">
            <h3>· 机构认证</h3>
            <dl>
              <dt>[ 邮件标题 ]</dt>
              <dd>
                <p>达人申请-用户名-机构认证</p>
              </dd>
            </dl>
            <dl>
              <dt>[ 邮件标题 ]</dt>
              <dd>
                <p>用户名：北京匡时</p>
                <p>在艺号： 11111111</p>
                <p>机构全名：北京匡时国际拍卖有限公司</p>
                <p>管理员真实姓名：李幕白</p>
                <p>管理员手机号码：13812341234</p>
                <p>常用邮箱：limubai@council.com.cn</p>
              </dd>
            </dl>
            <dl>
              <dt>[ 邮件标题 ]</dt>
              <dd>
                <p>工商营业执照</p>
                <p>用户身份证正反面或护照封面和首页</p>
                <p>职位证明（如：名片/工牌/在职证明）</p>
              </dd>
            </dl>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import Header from '../common/header'

export default {
  name: 'ArtIdentify',
  components: { 'app-header': Header },
  created() {
    document.querySelector('body').classList.add('auth')
  },
  beforeDestroy() {
    document.querySelector('body').classList.remove('auth')
  }
}
</script>
<style>
/*未授权*/
.auth {
  background-color: #3c3c3c;
}
.auth .header .inner {
  width: 1348px;
  padding: 32px 0;
}
.auth-wrapper {
  background-color: #fff;
  width: 1348px;
  margin: 0 auto;
}
.auth-wrapper .inner {
  padding: 96px;
}
.auth-title {
  text-align: center;
  font-size: 32px;
  font-weight: normal;
  color: #3c3c3c;
  margin-bottom: 40px;
}
.auth-title i {
  display: inline-block;
  width: 48px;
  height: 48px;
  margin-right: 35px;
  vertical-align: middle;
  background: url('../../../assets/img/admin/no_auth.png') no-repeat;
}
.auth-desc {
  font-size: 22px;
  text-align: center;
  color: #3c3c3c;
}
.auth-desc a {
  font-size: 28px;
  color: #4ba3e6;
}
.auth-content {
  clear: both;
  overflow: hidden;
  margin-top: 70px;
}
.auth-item {
  float: left;
  width: 360px;
  height: 540px;
  margin-left: 38px;
  background-color: #3c3c3c;
  color: #fff;
}
.auth-item:first-child {
  margin-left: 0;
}
.auth-item h3 {
  margin: 34px 34px 30px;
  font-size: 20px;
  font-weight: normal;
  color: #fff;
}
.auth-item h3 b {
  font-weight: bold;
}
.auth-item dl {
  margin: 0 34px 20px;
  overflow: hidden;
}
.auth-item dt {
  color: #4daef9;
  margin-bottom: 12px;
}
.auth-item dd p {
  margin-bottom: 8px;
}
</style>
